export default __webpack_public_path__ + "static/media/resume.1803adb1.pdf";